import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/periods')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/period' })
  },
})
